import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "../NewIPDPatientAdmission.module.css";

const AdmissionDetails = ({ formData, handleInputChange, doctorsList = [], availableBeds = [] }) => {
  const { t } = useTranslation();

  // Derived data for dropdowns
  const uniqueFloors = [...new Set(availableBeds.map(b => b.floor))];

  const filteredWards = availableBeds
    .filter(b => b.floor === formData.wardBed?.floor)
    .map(b => b.wardName);
  const uniqueWards = [...new Set(filteredWards)];

  const filteredBeds = availableBeds
    .filter(b => b.floor === formData.wardBed?.floor && b.wardName === formData.wardBed?.wardName);

  return (
    <div className={styles.section}>
      <h3><FaCalendarAlt /> {t("Admission Details")}</h3>
      <div className={styles.grid3}>
        <div>
          <label>{t("Admission Date & Time")} <span className={styles.mandatoryStar}>*</span></label>
          <input
            type="datetime-local"
            name="admissionDateTime"
            value={formData.admissionDateTime}
            onChange={handleInputChange}
          />
        </div>
        <div>
          <label>{t("Floor Number")} <span className={styles.mandatoryStar}>*</span></label>
          <select
            name="wardBed.floor"
            value={formData.wardBed?.floor || ""}
            onChange={handleInputChange}
            className="themed-select"
          >
            <option value="">{t("Select Floor")}</option>
            {uniqueFloors.map(floor => (
              <option key={floor} value={floor}>{floor}</option>
            ))}
          </select>
        </div>
        <div>
          <label>{t("Ward/Room Type")} <span className={styles.mandatoryStar}>*</span></label>
          <select
            name="wardBed.wardName"
            value={formData.wardBed?.wardName || ""}
            onChange={handleInputChange}
            disabled={!formData.wardBed?.floor}
            className="themed-select"
          >
            <option value="">{t("Select Ward")}</option>
            {uniqueWards.map(ward => (
              <option key={ward} value={ward}>{ward}</option>
            ))}
          </select>
        </div>
      </div>

      <div className={styles.grid3} style={{ marginTop: "1rem" }}>
        <div>
          <label>{t("Bed Number")} <span className={styles.mandatoryStar}>*</span></label>
          <select
            name="wardBed.id"
            value={formData.wardBed?.id || ""}
            onChange={handleInputChange}
            disabled={!formData.wardBed?.wardName}
            className="themed-select"
          >
            <option value="">{t("Select Bed")}</option>
            {filteredBeds.map(bed => (
              <option key={bed.id} value={bed.id}>{bed.bedNumber}</option>
            ))}
          </select>
        </div>
        <div>
          <label>{t("Status")} <span className={styles.mandatoryStar}>*</span></label>
          <select name="status" value={formData.status} onChange={handleInputChange} className="themed-select">
            <option value="ACTIVE">{t("ACTIVE")}</option>
            <option value="DISCHARGED">{t("DISCHARGED")}</option>
            <option value="TRANSFERRED">{t("TRANSFERRED")}</option>
            <option value="CANCELLED">{t("CANCELLED")}</option>
          </select>
        </div>
        <div>
          <label>{t("Blood Group")}</label>
          <select name="bloodGroup" value={formData.bloodGroup} onChange={handleInputChange} className="themed-select">
            <option value="">{t("Select Blood Group")}</option>
            <option value="A+">A+</option>
            <option value="A-">A-</option>
            <option value="B+">B+</option>
            <option value="B-">B-</option>
            <option value="AB+">AB+</option>
            <option value="AB-">AB-</option>
            <option value="O+">O+</option>
            <option value="O-">O-</option>
          </select>
        </div>
      </div>

      <div className={styles.grid3} style={{ marginTop: "1rem" }}>

        <div>
          <label>{t("Consultant Doctor")} <span className={styles.mandatoryStar}>*</span></label>
          <select
            name="doctorId.userId"
            value={formData.doctorId?.userId || ""}
            onChange={handleInputChange}
            className="themed-select"
          >
            <option value="">{t("Select Doctor")}</option>
            {doctorsList.map(dr => (
              <option key={dr.userId} value={dr.userId}>
                {t("Dr.")} {dr.firstName} {dr.lastName} ({dr.degree})
              </option>
            ))}
          </select>
        </div>
        <div>
          <label>{t("Admission Reason")} <span className={styles.mandatoryStar}>*</span></label>
          <input type="text" name="admissionReason" value={formData.admissionReason} onChange={handleInputChange} placeholder={t("Enter admission reason")} />
        </div>
        <div>
          <label>{t("Referred By Dr")}</label>
          <input
            type="text"
            name="referredBy"
            value={formData.referredBy || ""}
            onChange={(e) => {
              const { name, value } = e.target;
              const filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
              handleInputChange({ target: { name, value: filteredValue } });
            }}
            placeholder={t("Referred By")}
          />
        </div>

      </div>
    </div>
  );
};

export default AdmissionDetails;
